module.exports = __webpack_public_path__ + "img/solution18.23e63d24.png";